(ns error-boundary.views
  (:require
    [reagent.core :as r]
    [very.sentry.core :as sentry]))

(defn error-boundary
  ([no-error has-error] (error-boundary no-error has-error (r/atom nil)))
  ([no-error has-error error-atom]
   (assert (and no-error has-error) "An error boundry requires exactly two
                                    children, a has-no-errors view, and a
                                    has-errors view.")
   (r/create-class
     {:display-name "error-boundary"
      :component-did-catch (fn [this e info]
                             (sentry/report e info)
                             (reset! error-atom e))
      :reagent-render
      (fn [valid invalid]
        (if-not @error-atom
          no-error
          has-error))})))


